import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Chip, useTheme } from 'react-native-paper';

interface PersonInChargeChipProps {
  readonly label: string;
  readonly saving: boolean;
  readonly onPress: () => void;
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
});

export const PersonInChargeChip = ({ label, saving, onPress }: PersonInChargeChipProps) => {
  const theme = useTheme();

  return (
    <View style={styles.container}>
      <Chip
        icon={saving ? undefined : 'account-outline'}
        disabled={saving}
        mode="outlined"
        textStyle={{ color: theme.colors.onSurface }}
        onPress={onPress}>
        {saving ? <ActivityIndicator size={12} /> : label}
      </Chip>
    </View>
  );
};
